module.exports = __webpack_public_path__ + "7ed09cd7ed0882c3315eb6de15392f3e.jpg";